var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component-span> <div uib-carousel active=\"$ctrl.active\" interval=\"$ctrl.interval\"> <div uib-slide ng-style=\"{ 'background-image': 'url(' + slide.ImageUrl + ')' }\" ng-repeat=\"slide in $ctrl.slides track by $index\" class=\"winres-slide\" index=\"$index\"> <div class=\"carousel-caption\"> <h4 ng-bind=\"::slide.Title\"></h4> <p ng-bind=\"::slide.Text\"></p> </div> </div> </div> </web-component-span>";
var id1="winresCarousel.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresCarousel/winresCarousel.html
// module id = 281
// module chunks = 2